import { PropType } from 'vue-demi';

import { IAgent, Contact, AgentStatus, RuleGroup } from '@/types';
import { AvatarOptions } from '@onereach/hitl-base-avatars';
import { ItemAction, StatusType, AgentSearchOptions } from './types';

export const DEFAULT_DATA_KEY = 'id';
export const AVATAR_PROP = {
  type: Object as PropType<AvatarOptions>,
  default: undefined,
};

export const PERSON_PROP = {
  type: Object as PropType<IAgent | Contact>,
  default: undefined,
};

export const AGENT_PROP = {
  type: Object as PropType<IAgent>,
  default: undefined,
};

export const AGENTS_PROP = {
  type: Array as PropType<IAgent[]>,
  default: () => [],
};

export const STATUS_TYPE_PROP = {
  type: String as PropType<StatusType>,
  default: '',
};

export const SIZE_PROP = {
  type: String as PropType<'desktop' | 'mobile'>,
  default: 'desktop' as const,
};

export const ITEM_ACTIONS_PROP = {
  type: Array as PropType<ItemAction[]>,
  default: () => [],
};

export const ITEM_ACTIONS_DISPLAY_PROP = {
  type: String as PropType<'inline' | 'popup'>,
  default: 'inline' as const,
};

export const AGENT_SEARCH_OPTIONS_PROP = {
  type: Object as PropType<AgentSearchOptions>,
  default: () => ({}),
};

export const RULE_GROUPS_PROP = {
  type: Array as PropType<RuleGroup[]>,
  default: () => [],
};

export const STATUS_OPTIONS_PROP = {
  type: Array as PropType<AgentStatus[]>,
  default: () => [],
};
